import LoginForm from "../../Components/Forms/LoginForm"; // ✅ Correct import

const Login = () => {
    return (
        <div>
            <LoginForm />
        </div>
    );
};

export default Login;
